export const SETUP_PROJECT = '@ONBOARDINGNOW/SETUP_PROJECT'
export const SETUP_CHANNELS = '@ONBOARDINGNOW/SETUP_CHANNELS'

export const CHOOSE_PLUGIN = '@ONBOARDINGNOW/CHOOSE_PLUGIN'
export const PLUGIN_CUSTOM = '@ONBOARDINGNOW/PLUGIN_CUSTOM'
export const PLUGIN_WORDPRESS = '@ONBOARDINGNOW/PLUGIN_WORDPRESS'

export const CONGRATGS = '@ONBOARDINGNOW/CONGRATS'
